import Feature from 'owa-feature-flags/lib/store/schema/Feature';

/**
 * Please keep in alphabetical order for ease of reading
 */
export default {
    'ads-GDPRLGPD-managebuttonprimarytext-mini': <Feature>{},
    'ads-LGPD-acceptrejectui': {},
    'ads-mini-useast-051': {},
    'ads-native-MSAN-CC-AFR-202210': <Feature>{},
    'ads-native-MSAN-CC-LATAM-202210': <Feature>{},
    'ads-native-MSAN-CC-MENA-Green-202210': <Feature>{},
    'ads-native-MSAN-CC-MENA-Red-202210': <Feature>{},
    'ads-native-MSAN-Countries-AAML-202210': <Feature>{},
    'ads-native-MSAN-Placement-useTagId': <Feature>{},
    'ads-native-MSAN-SendContentUrl': <Feature>{},
    'ads-native-MSAN-SendDevice': <Feature>{},
    'ads-native-MSAN-SendExpHeader-SendT': <Feature>{},
    'ads-native-MSAN-SendExpHeader-SendC': <Feature>{},
    'ads-native-MSAN-SenderUseBrand': <Feature>{},
    'ads-native-MSAN-SendRid': <Feature>{},
    'ads-optout-NewEndpoint-mini': <Feature>{},
    'ads-Prompt-TestSkipCheck': <Feature>{},
    'adsexp-mini-prebidTimeout-1s': <Feature>{},
    'adsexp-mini-prebidTimeout-3s': <Feature>{},
    'adsexp-mini-NoTLClientCall-202211-treatment': <Feature>{},
    'adsexp-mini-NoTLClientCall-202211-control': <Feature>{},
    'auth-progressiveWebApp': <Feature>{},
    'cmp-encryption': <Feature>{},
    'doc-consumerUrl': <Feature>{},
    'miniAE-Refresh-202206-20s': <Feature>{},
    'miniAE-Refresh-202206-30s': <Feature>{},
    'miniAE-Refresh-202206-40s': <Feature>{},
    'miniAE-Refresh-202206-control': <Feature>{},
    'miniAE-RemoveAdHonorList-treatment': <Feature>{},
    'miniAE-RemoveAdHonorList-control': <Feature>{},
    'miniAE-ReadAdHonorList-treatment': <Feature>{},
    'miniAE-ReadAdHonorList-control': <Feature>{},
    'miniAE-FloatingAd-3rdPosition': <Feature>{},
    'miniAE-FloatingAd-4thPosition': <Feature>{},
    'miniAE-FloatingAd-5thPosition': <Feature>{},
    'miniAE-FloatingAd-control': <Feature>{},
    'mini-errorpopup': <Feature>{},
    'mini-feedbackDF': <Feature>{},
    'mini-MSAN-EMEA-202204': <Feature>{},
    'mini-markAsJunkMultiSelect': <Feature>{},
    'mini-serviceworker': <Feature>{},
    'mini-suggestionsQF': <Feature>{},
    'mini-surveyV1': <Feature>{},
    'mini-sw-enabled': <Feature>{},
    'mini-sw-enabled-chrome': <Feature>{},
    'mini-sw-enabled-safari': <Feature>{},
    'rp-requestPersonaResponseShape': <Feature>{},
    'tri-favorites-roaming': <Feature>{}, // Same as owa-mail
    'mini-cal-agenda-avatars': <Feature>{},
    'mini-feedback-link': <Feature>{},
    'mini-liveSite-deleteMail': <Feature>{},
    'mini-wsb': <Feature>{},
    'mini-unified-search': <Feature>{},
    'mini-mail-a2hs-customPrompt': <Feature>{},
    'mini-mail-a2hs-persistent': <Feature>{},
    'mini-cal-bootstrap-diagnostics': <Feature>{},
    'mini-edge-upsell-experiment': <Feature>{},
    'mini-mailto': <Feature>{},
    'mini-push-notification-mail': <Feature>{},
    'mini-push-notification-reminder': <Feature>{},
    'mini-reactions': <Feature>{},
    // suggested replies
    'mini-suggested-replies': <Feature>{},
    // experiment for removing unread indicator in Ads
    'mini-ads-noUnreadIndicator-treatment': <Feature>{},
    'mini-ads-noUnreadIndicator-control': <Feature>{},
    // swipe down to refresh mail list
    'mini-swipe-refresh': <Feature>{},
    // block Sender Feature
    'mini-block-sender': <Feature>{},
    // Outlook Lite feature flags
    'lite-block-tenant': <Feature>{},
    // session data caching in OutlookLite
    'lite-offline-session-data': <Feature>{},
    //multi account using mecontrol
    'mini-me-control': <Feature>{},
    // Feature flags to be used only for testing different attachment policy scenarios
    // MBP: Mail box policy, CAP: conditional access policy
    'mini-attachment-MBP-directFileAccessDisabled': <Feature>{},
    'mini-attachment-MBP-wacViewingDisabled': <Feature>{},
    'mini-attachment-CAP-readOnly': <Feature>{},
    'mini-attachment-CAP-readOnlyPlusAttachmentsBlocked': <Feature>{},
    'mini-attachment-test-directFileAccessAndWacViewingDisabled': <Feature>{},
    // Pdf preview
    'mini-attachment-pdf-preview': <Feature>{},
    // Wac preview
    'mini-attachment-wxp-preview': <Feature>{},
    // report a concern feature flag
    'mini-report-a-concern': <Feature>{},
    //feature flag to remove classification in inbox shopping
    'mini-inbox-shopping-disabling-classifier': <Feature>{},
    //feature flag to make the inbox banner clickable
    'mini-inbox-shopping-banner-clickable': <Feature>{},
    'lite-refer-friends-and-family': <Feature>{},
    // USQ
    'mini-usq': <Feature>{},
    //checking country filter of control tower
    'mini-country-filter-check': <Feature>{},
    //feature flag to enable the vernacular compose scenarios
    'mini-vernacular-compose': <Feature>{},
    // Interim solution for compliant meetings in mini
    'mini-compliant-meeting-interim': <Feature>{},
};
